import React from 'react';
import Icon from '../media/icon.png';
import { Image } from 'semantic-ui-react';

class Otheruser extends React.Component {

  state = {
    image: Icon,

  }

  render() {
    return (
      <div><br/><br/>
        <center>
          <b style={{fontSize: 35, color: '#abb119'}}>VAIGAI CLAAS ADMIN PANEL</b>
        </center>
      </div>
    );
  }
}

export default Otheruser;
